import { Layout, SignalGroupTable } from "components"
export const SignalGroup = () => {
 return (
  <Layout>
   <SignalGroupTable />
  </Layout>
 )
}
